// essa função recebe dois parâmetros:
// um array de objetos para ser reordenado
// uma string com o nome da chave que deve ser usada para ordernar
export function ordenarArrayDeObjetos(arrayDeObjetos, chave) {
    if (!Array.isArray(arrayDeObjetos) || typeof chave !== 'string') {
        throw new Error('Os parâmetros fornecidos são inválidos.');
    }

    return arrayDeObjetos.sort((a, b) => {
        if (a[chave] < b[chave]) {
            return -1;
        }
        if (a[chave] > b[chave]) {
            return 1;
        }
        return 0;
    });
}